// in ascending order of priority (lower priority first)
export enum TimerPriority {
  chatPage,
  phoneCall,
}
